import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { arrayOf, bool, func, node, object, shape, exact, string, number } from 'prop-types';
import RCE5 from './rce5';
import { RceConfigContext, RceConfigKeys } from '@instructure/quiz-common';
import { areAllRcsKeysPresent } from './rce5Utils';
export var RCE5ParameterAdapter = /*#__PURE__*/function (_Component) {
  function RCE5ParameterAdapter() {
    var _this;
    _classCallCheck(this, RCE5ParameterAdapter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RCE5ParameterAdapter, [].concat(args));
    _defineProperty(_this, "handleRef", function (node) {
      return _this.rce = node;
    });
    _defineProperty(_this, "getValueFromPropsOrContext", function (propName) {
      var _this$context;
      var contextKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : propName;
      return _this.props[propName] || ((_this$context = _this.context) === null || _this$context === void 0 ? void 0 : _this$context[contextKey]);
    });
    _defineProperty(_this, "composeMandatoryProps", function () {
      return {
        autoFocus: _this.props.autoFocus,
        textareaId: _this.props.textareaId,
        defaultContent: _this.props.defaultContent,
        stem: _this.props.stem,
        height: _this.props.height,
        editorOptions: _this.props.editorOptions,
        actsAsInput: _this.props.actsAsInput,
        readOnly: _this.props.readOnly,
        placeholder: _this.props.placeholder,
        isRequired: _this.props.isRequired,
        label: _this.props.label,
        messages: _this.props.messages,
        onChange: _this.props.onChange,
        onFocus: _this.props.onFocus,
        onBlur: _this.props.onBlur,
        rendererEnhancement: _this.getValueFromPropsOrContext('rendererEnhancement'),
        featureFlags: _this.getValueFromPropsOrContext('featureFlags')
      };
    });
    _defineProperty(_this, "isRcsParamSourceComplete", function () {
      return areAllRcsKeysPresent(_this.getValueFromPropsOrContext('rcsProps', 'rcs'));
    });
    _defineProperty(_this, "renderRce5WithoutRcs", function () {
      return /*#__PURE__*/React.createElement(RCE5, Object.assign({}, _this.composeMandatoryProps(), {
        defaultRceSettings: _this.getValueFromPropsOrContext('defaultRceSettings'),
        ref: _this.handleRef
      }));
    });
    _defineProperty(_this, "renderRce5WithRcs", function () {
      return /*#__PURE__*/React.createElement(RCE5, Object.assign({}, _this.composeMandatoryProps(), {
        rcsProps: _this.getValueFromPropsOrContext('rcsProps', 'rcs'),
        ltiApps: _this.getValueFromPropsOrContext('ltiApps'),
        defaultRceSettings: _this.getValueFromPropsOrContext('defaultRceSettings'),
        ref: _this.handleRef
      }));
    });
    _defineProperty(_this, "render", function () {
      return _this.isRcsParamSourceComplete() ? _this.renderRce5WithRcs() : _this.renderRce5WithoutRcs();
    });
    return _this;
  }
  _inherits(RCE5ParameterAdapter, _Component);
  return _createClass(RCE5ParameterAdapter, [{
    key: "id",
    get: /* istanbul ignore next */
    function get() {
      return this.rce.id;
    }
  }]);
}(Component);
_defineProperty(RCE5ParameterAdapter, "contextType", RceConfigContext);
_defineProperty(RCE5ParameterAdapter, "propTypes", {
  autoFocus: bool,
  textareaId: string.isRequired,
  defaultContent: string,
  stem: string,
  height: number,
  actsAsInput: bool,
  readOnly: bool,
  placeholder: string,
  isRequired: bool,
  label: node.isRequired,
  messages: arrayOf(shape({
    type: string.isRequired
  })),
  onChange: func,
  onFocus: func,
  onBlur: func,
  editorOptions: shape({
    spellCheck: bool.isRequired,
    wordCount: bool.isRequired
  }),
  rcsProps: shape(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RceConfigKeys.contextId, string.isRequired), RceConfigKeys.contextType, string.isRequired), RceConfigKeys.canvasUserId, string.isRequired), RceConfigKeys.resourceId, string), RceConfigKeys.resourceType, string), RceConfigKeys.rcsHost, string.isRequired), RceConfigKeys.rcsJwt, string.isRequired), RceConfigKeys.rcsJwtRefreshFn, func.isRequired), RceConfigKeys.canvasConfig, object.isRequired)),
  rendererEnhancement: shape(_defineProperty({}, RceConfigKeys.canvasOrigin, string)),
  ltiApps: exact({
    canvasToolId: string,
    editorButtons: arrayOf(object),
    ltiIframeAllowances: arrayOf(string)
  }),
  featureFlags: shape(_defineProperty({}, RceConfigKeys.displayOldLinks, bool))
});
_defineProperty(RCE5ParameterAdapter, "defaultProps", {
  autoFocus: false,
  defaultContent: '',
  stem: '',
  height: null,
  actsAsInput: false,
  readOnly: false,
  placeholder: '',
  isRequired: false,
  messages: [],
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  editorOptions: null,
  rcsProps: null,
  rendererEnhancement: null,
  ltiApps: null,
  featureFlags: null
});
export default RCE5ParameterAdapter;